
import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject
} from '@angular/core';
import { RadioNode, RadiosComponent, ToolkitApiService } from '@jeppesen-foreflight/jmkw-toolkit';
import { ExtendedMap, ThemeInfo } from '@jeppesen-foreflight/jmkw-types';

@Component({
  selector: 'jmkw-theme-radios-popout',
  standalone: true,
  imports: [RadiosComponent],
  templateUrl: './theme-radios-popout.component.html',
  styleUrls: ['./theme-radios-popout.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ThemeRadiosPopoutComponent {
  automationKey = 'theme-popout';
  private readonly _api = inject(ToolkitApiService);

  radioNodeMap?: ExtendedMap<RadioNode> = this._convertThemeIdsToRadioNodes(
    this._api.getThemeOptions()
  );
  selectedThemeId = computed(() => this._api.currentTheme()()?.id);

  private _convertThemeIdsToRadioNodes(themes?: ThemeInfo[]) {
    return themes?.reduce((radioMap, theme) => {
      radioMap.set(
        theme.id,
        new RadioNode({
          id: theme.id,
          label: theme.metadata.name,
          onChange: (id: string, node: RadioNode) => {
            this._api.changeTheme(node.id);
          }
        })
      );

      return radioMap;
    }, new ExtendedMap<RadioNode>());
  }
}
